export default __webpack_public_path__ + "static/media/profile3.aed1c7b0.png";